import { ReactNode } from 'react';
import { AuthPageHeader } from '../AuthPageHeader/AuthPageHeader';
import PasswordImg from '../../../../assets/img/password-reset.jpg';
import { useAppSelector } from '../../../../store';
import { selectTheme } from '../../../../store/theme';
import cn from 'classnames';
import './NewLayout.scss';

type Props = {
  img?: string;
  isWideForm?: boolean;
  children: ReactNode;
};

/** layout исп. только для лк (вместо AuthLayout & SimpleLayout), компании которые исп. новый дизайн срм;
 * так же исп. переменная пока в кач-ве костыля - IS_NEW_CRM на стр. авторизаций
 */
export const NewLayout = ({ children, img, isWideForm }: Props) => {
  const { reset_password } = useAppSelector(selectTheme);

  return (
    <div className="new-layout _pos-r _flex _flex-col _flex-xy-c _h-100vh">
      <AuthPageHeader />
      <img src={img || reset_password || PasswordImg} className="_object-fit" alt="" />
      <div className={cn('page-form-wrap _pos-r', { 'page-form-wrap-wide': isWideForm })}>
        {children}
      </div>
      <div className={cn('copyright _fz-14', { 'copyright-wide': isWideForm })}>
        © {new Date().getFullYear()} {process.env.REACT_APP_COMPANY_NAME}, Inc.
      </div>
    </div>
  );
};
